import { useEffect, useState } from 'react';
import axios from 'axios';
import { apiBase } from '../utils/authHeaders';
import { useCkScope, scopeKey, requestConfig } from './CkOperationsShared';
export const decisionsApi = axios.create({ baseURL: `${apiBase()}/api/decisions` });
export function useDecisionsNavEnabled(token) {
  const scope = useCkScope(token);
  const key = scopeKey(scope);
  const [allowedKey, setAllowedKey] = useState('');
  useEffect(() => {
    const controller = new AbortController();
    setAllowedKey('');
    if (scope.orgId && scope.token) decisionsApi.get('/capabilities', requestConfig(scope, controller.signal))
      .then(res => { if (!controller.signal.aborted && res.data?.can_read === true) setAllowedKey(key); }).catch(() => {});
    return () => controller.abort();
  }, [key, scope]);
  return key === allowedKey;
}
export function labelOptions(record, cls) {
  if (record.criteria_keys?.length) return record.criteria_keys;
  const criteria = cls?.question?.criteria;
  return criteria && !Array.isArray(criteria) && typeof criteria === 'object' ? Object.keys(criteria) : [];
}
